.chordPaper {
  padding: var(--tuna-spacing-1);
  padding-bottom: 0;
}

.chordPaperSelected {
  background-color: var(--tuna-palette-action-hover);
  border-color: var(--tuna-palette-primary-main);
  border-width: 2px;
  cursor: pointer;
}
